import React, { useEffect, useState } from "react";
import { Container, Row, Col, Button, Modal } from "react-bootstrap";
import MoneyViewLogo from "../../assets/images/congratulations/logo-light.png";
import Celebration from "../../assets/images/congratulations/gift.png";
import FinlabLogo from "../../assets/images/header/logoback.svg";
import { API_URL } from "../../config/constant";
import axios from "axios";
import { QRCodeSVG } from "qrcode.react"; // Correct import

export default function Index() {
  // State for offer
  const [offer, setOffer] = useState(null);
  const [loading, setLoading] = useState(false);
  const [showQR, setShowQR] = useState(false);

  // Helper to get leadId from URL
  function getLeadId() {
    const params = new URLSearchParams(window.location.search);
    return params.get("leadId");
  }

  useEffect(() => {
    const leadId = getLeadId();
    if (!leadId) return;
    setLoading(true);
    axios
      .post(`${API_URL}mv/fetch-offers`, { leadId })
      .then((res) => {
        const data = res.data;
        // Updated response parsing for nested offers
        if (
          data.status === "success" &&
          data.offers &&
          data.offers.status === "success" &&
          Array.isArray(data.offers.offerObjects) &&
          data.offers.offerObjects.length > 0
        ) {
          setOffer(data.offers.offerObjects[0]);
        }
      })
      .finally(() => setLoading(false));
  }, []);

  // Detect mobile
  const isApple = /iPhone|iPad|iPod/i.test(navigator.userAgent);
  const isAndroid = /Android/i.test(navigator.userAgent);
  const isMobile = isApple || isAndroid;

  const buttonText = "Download App";
  const playStoreUrl =
    "https://play.google.com/store/apps/details?id=com.whizdm.moneyview.loans&hl=en_IN&gl=IN&pli=1";
  const buttonLink = isApple
    ? "https://apps.apple.com/in/app/moneyview-loans-investments/id6468976019"
    : playStoreUrl;

  return (
    <Container fluid className="loan-offer-container">
      {/* Header Section */}
      <Row className="congratulations-header align-items-center">
        <Col xs={12} md={6} className="text-start">
          <img
            src={FinlabLogo}
            alt="Finlab Logo"
            className="congratulations-logo"
          />
          <span className="mx-2">in partnership with</span>
          <img
            src={MoneyViewLogo}
            alt="MoneyView Logo"
            className=""
            style={{ width: "120px", height: "auto" }}
          />
        </Col>
        <Col xs={12} md={6} className="text-end mt-3 mt-md-0">
          <i className="bi bi-person-circle congratulations-user-icon"></i>
        </Col>
      </Row>

      {/* Content Section */}
      <Row className="congratulations-content text-center justify-content-center my-4">
        <Col xs={12} sm={10} md={8} lg={6}>
          <div className="congratulations-offer-card">
            <div className="congratulations-icon-container">
              <i className="bi bi-gift-fill congratulations-offer-icon">
                <img
                  src={Celebration}
                  alt="Celebration symbol"
                  className="celebration-symbol"
                />
              </i>
            </div>
            <h2>Congratulations!</h2>
            {loading ? (
              <div
                style={{
                  minHeight: 60,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <span>Loading your offer...</span>
              </div>
            ) : offer ? (
              <>
                <p>
                  You are eligible for a loan of{" "}
                  <strong>₹{offer.loanAmount.toLocaleString()}*</strong>
                </p>
                <p
                  style={{
                    fontSize: "15px", // default is 16px, so 1px smaller
                  }}
                >
                  EMI:{" "}
                  <strong>₹{Math.round(offer.loanEmi).toLocaleString()}</strong>
                  &nbsp; | &nbsp; Tenure:{" "}
                  <strong>{offer.loanTenure} months</strong>
                  &nbsp; | &nbsp; Interest:{" "}
                  <strong>{offer.rateOfInterest}%</strong>
                </p>
                <p
                  style={{
                    fontSize: "15px",
                  }}
                >
                  Processing Fee:{" "}
                  <strong>
                    ₹{Math.round(offer.processingFeeAmount).toLocaleString()}
                  </strong>
                </p>
              </>
            ) : (
              <p>No offer found.</p>
            )}
            <p className="congratulations-disclaimer">
              *This is a tentative loan offer and the final loan offer might be
              subject to change
            </p>
            <Button
              variant="success"
              className="congratulations-download-button"
              onClick={() => {
                if (isMobile) {
                  window.open(buttonLink, "_blank");
                } else {
                  setShowQR(true);
                }
              }}
            >
              {buttonText}
            </Button>
            {/* QR Code Modal for Desktop */}
            <Modal show={showQR} onHide={() => setShowQR(false)} centered>
              <Modal.Header closeButton>
                <Modal.Title>Scan to Download App</Modal.Title>
              </Modal.Header>
              <Modal.Body className="text-center">
                <QRCodeSVG value={playStoreUrl} size={180} />
                <div style={{ marginTop: 16 }}>
                  <a
                    href={playStoreUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Or click here to open Play Store
                  </a>
                </div>
              </Modal.Body>
            </Modal>
          </div>
        </Col>
      </Row>

      {/* Footer Section */}
      <Row className="congratulations-footer text-center">
        <Col xs={12}>
          <p>Safe and secure &nbsp; | &nbsp; Privacy</p>
          <p>© 2024 Finlab.One Pvt. Ltd.</p>
        </Col>
      </Row>
    </Container>
  );
}
